var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-mobile-view"},[_c('div',{staticClass:"custom-splash-bg"},[_c('Ellipsis')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }